import { fetchApi } from '@/config/axiosSetting';
import {
  GetAdjusterRankQueryParamsType,
  GetAdjusterRankQueryResponseType,
} from './getAdjusterRankQuery.type';
import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';

export const getAdjusterRankFunction = (
  params: GetAdjusterRankQueryParamsType,
): Promise<PaginationResponseType<GetAdjusterRankQueryResponseType>> => {
  return fetchApi.get('/survey/adjuster_ranks/', { params });
};
